import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  activateAgency,
  assignPlan,
  createAgency,
  deleteAgency,
  listAgencies,
  listPlans,
  suspendAgency,
  unassignPlan,
  type CreateAgencyInput,
} from '@/api/platform'

export function useAgencies() {
  return useQuery({ queryKey: ['platform-agencies'], queryFn: listAgencies })
}

export function useCreateAgency() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateAgencyInput) => createAgency(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['platform-agencies'] }),
  })
}

export function useSuspendAgency() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => suspendAgency(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['platform-agencies'] }),
  })
}

export function useActivateAgency() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => activateAgency(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['platform-agencies'] }),
  })
}

export function useDeleteAgency() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteAgency(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['platform-agencies'] }),
  })
}

export function usePlans() {
  return useQuery({ queryKey: ['platform-plans'], queryFn: listPlans })
}

export function useAssignPlan() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, planKey }: { id: string; planKey: string | null }) =>
      planKey ? assignPlan(id, planKey) : unassignPlan(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['platform-agencies'] }),
  })
}
